var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCamera = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 10.4565C2 8.27136 3.77136 6.5 5.95645 6.5V6.5C6.58953 6.5 7.16169 6.12272 7.41107 5.54083L7.72075 4.81824C8.19349 3.71519 9.2781 3 10.4782 3H12H13.5218C14.7219 3 15.8065 3.71519 16.2792 4.81824L16.5889 5.54083C16.8383 6.12272 17.4105 6.5 18.0435 6.5V6.5C20.2286 6.5 22 8.27136 22 10.4565V15.5C22 18.2614 19.7614 20.5 17 20.5H7C4.23858 20.5 2 18.2614 2 15.5V10.4565Z",
    stroke: "current",
    strokeWidth: 1.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 3,
    transform: "matrix(-1 0 0 1 12 12.5)",
    stroke: "current",
    strokeWidth: 1.5
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCamera);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/camera.ca91f29b189896f08603b9de82432301.svg";